import type { ReactNode } from "react";

import { Heading, Text } from "@/shared/ui/common";

interface SectionHeaderProps {
  title: ReactNode;
  description?: string | null;
}

export const SectionHeader = ({ title, description }: SectionHeaderProps) => {
  return (
    <header className="flex flex-col items-center gap-3">
      <Heading level={1} color="primary" align="center">
        {title}
      </Heading>

      {description && (
        <Text as="p" align="center" size="large">
          {description}
        </Text>
      )}
    </header>
  );
};
